import { Flex } from 'antd';

import type { ReactNode } from 'react';

type ModalFooterProps = {
  /** Danger/destructive actions only (Delete, Unpublish, Reject). Rendered on the left. */
  danger?: ReactNode;
  /** Cancel, Close, Done, Save, Submit, Next, utility. Rendered on the right. */
  actions?: ReactNode;
};

const ModalFooter = ({ danger, actions }: ModalFooterProps) => (
  <Flex
    align="center"
    justify="space-between"
    wrap
    style={{ width: '100%' }}
    data-testid="ui-modal-footer"
  >
    <Flex align="center" gap="small" wrap data-testid="ui-modal-footer-danger">
      {danger}
    </Flex>
    <Flex align="center" gap="small" wrap data-testid="ui-modal-footer-actions">
      {actions}
    </Flex>
  </Flex>
);

export default ModalFooter;
